class LyckdCollection extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.selectCategory(new URL(window.location.href).searchParams.get('category') || 'all');

    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-category]');
      if (!button || !this.contains(button)) return;
      const category = button.dataset.category;
      this.selectCategory(category);
      const url = new URL(window.location.href);
      if (category === 'all') url.searchParams.delete('category');
      else url.searchParams.set('category', category);
      url.searchParams.delete('page');
      window.history.replaceState(null, '', url.href);
    }, { signal });

    this.addEventListener('change', (event) => {
      if (!event.target.matches('[data-sort-select]')) return;
      const url = new URL(window.location.href);
      const sort = this.querySelector('[data-sort-select]');
      // Recommended follows each collection's configured default ordering.
      if (sort.selectedIndex === 0) url.searchParams.delete('sort_by');
      else url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.')) url.searchParams.delete(key);
      }
      url.hash = '';
      window.location.assign(url.href);
    }, { signal });

  }

  selectCategory(category) {
    const buttons = [...this.querySelectorAll('[data-category]')];
    if (!buttons.length) return;
    if (!buttons.some((button) => button.dataset.category === category)) category = 'all';
    for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.category === category));
    let visible = 0;
    for (const card of this.querySelectorAll('[data-product-categories]')) {
      const categories = card.dataset.productCategories.split(' ');
      card.hidden = category !== 'all' && !categories.includes(category);
      if (!card.hidden) visible++;
    }
    const bundlesPromo = this.querySelector('[data-bundles-promo]');
    if (bundlesPromo) bundlesPromo.hidden = category !== 'all';
    this.querySelector('[data-category-empty]').hidden = visible !== 0;
  }

  disconnectedCallback() { this.controller?.abort(); }
}

if (!customElements.get('lyckd-collection')) customElements.define('lyckd-collection', LyckdCollection);
